import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { useBranding } from "../BrandingProvider/BrandingProvider";
import { DEFAULT_MASK } from "../PostalCodeTextMask/usePostalCodeTextMask";
import Loading from "../loading";
import { useCompanyProviderModel } from "./CompanyProvider.request";
import { isValidUrl } from "../Navigation/navigationUtils";
const DEFAULT_FOOTER_ATTRIBUTION_MD = "[Meal Delivery Software By MealTrack](https://mealtrack.com/?utm_campaign=AppReferral&utm_source=MT&utm_medium={CompanyName})";
export const CompanyProvider = ({ children }) => {
    var _a, _b, _c, _d;
    const { data, loading, error, tokenMap } = useCompanyProviderModel();
    const { branding } = useBranding();
    if (loading || !data)
        return _jsx(Loading, { viewportHeight: "75vh" });
    if (error) {
        return _jsx(Loading, { error: true, text: error, viewportHeight: "75vh" });
    }
    //If Brand URL is set, use it. otherwise, use company config website.
    let homeUrl = ((_a = branding.BrandURL) === null || _a === void 0 ? void 0 : _a.Input) && ((_c = (_b = branding.BrandURL) === null || _b === void 0 ? void 0 : _b.Input) === null || _c === void 0 ? void 0 : _c.length) > 0
        ? branding.BrandURL.Input
        : data.website && data.website.length > 0
            ? data.website
            : "/";
    if (isValidUrl(branding.BrandURL.Input)) {
        //Append protocol if not present, assume SSL.
        homeUrl = homeUrl.indexOf("http") === -1 ? `https://${homeUrl}` : homeUrl;
    }
    const value = {
        culture: {
            cultureInfo: data.cultureInfo,
            currency: data.currencyType,
            countryCode: data.countryCode,
        },
        keys: data.keys,
        imgBaseUrl: data.imgBaseUrl,
        buildVersion: data.buildVersion,
        name: data.name,
        displayName: branding.BrandDisplayName.Input.length !== 0 ? branding.BrandDisplayName.Input : data.name,
        url: homeUrl,
        doesCompanyHaveOrderPage: data.doesCompanyHaveOrderPage,
        navOrderButtonText: data.navOrderButtonText,
        orderNowLink: data.orderNowLink,
        companyUsesKlaviyo: data.companyUsesKlaviyo,
        companyUsesSMS: data.companyUsesSMS,
        postalCodeMasks: data.postalCodeMasks,
        openedFromMobileApp: data.openedFromMobileApp,
        mobileRedirectFailureUrl: data.mobileRedirectFailureUrl,
        mobileRedirectSuccessUrl: data.mobileRedirectSuccessUrl,
        footerAttributionMD: (_d = data === null || data === void 0 ? void 0 : data.footerAttributionMD) !== null && _d !== void 0 ? _d : DEFAULT_FOOTER_ATTRIBUTION_MD,
        companyText: data.companyText,
        tokenMap: tokenMap,
        companySettingsCountry: data.companySettingsCountry,
    };
    return _jsx(CompanyContext.Provider, Object.assign({ value: value }, { children: children }));
};
export const CompanyContext = React.createContext({
    culture: {
        cultureInfo: "",
        currency: "",
        countryCode: "",
    },
    keys: [],
    displayName: "",
    name: "",
    url: "",
    imgBaseUrl: "",
    buildVersion: "",
    doesCompanyHaveOrderPage: false,
    navOrderButtonText: "Order Now",
    orderNowLink: "",
    postalCodeMasks: DEFAULT_MASK,
    companyUsesKlaviyo: false,
    companyUsesSMS: false,
    openedFromMobileApp: false,
    footerAttributionMD: DEFAULT_FOOTER_ATTRIBUTION_MD,
    companyText: [],
    tokenMap: new Map(),
    companySettingsCountry: "",
});
export const useCompany = () => useContext(CompanyContext);
